<script>import { getContext } from "svelte";
import FieldContainer from "./helper/FieldContainer.svelte";
import Select from "./helper/Select.svelte";
import { buildSelectOptions } from "./forms.js";
import { createFieldContext } from "./helper/field.js";
export let name = void 0;
export let label;
export let callToInput = void 0;
export let assistText = void 0;
export let story = void 0;
export let value = void 0;
export let error = "";
export let disabled = false;
export let options = void 0;
export let control = void 0;
export let locale = void 0;
export let context = void 0;
if (options === void 0) {
  if (control && locale) {
    options = buildSelectOptions(control, locale, context);
  }
}
const contextKey = createFieldContext(name, value, error, disabled, value === void 0);
const ctx = getContext(contextKey);
const ctxValue = ctx.value;
const ctxDisabled = ctx.disabled;
$: {
  ctx.value.set(value);
  ctx.error.set(error);
  ctx.disabled.set(disabled);
  ctx.empty.set(value === void 0);
}
$:
  value = $ctxValue;
$:
  disabled = $ctxDisabled;
$:
  props = {
    label,
    callToInput,
    assistText,
    story,
    contextKey
  };
</script>

<FieldContainer {...props}>
	<svelte:fragment slot="input">
		<Select {options} {contextKey} on:changed on:state />
	</svelte:fragment>
</FieldContainer>
